import React from "react";


export default function TranslationsTableFilters(props) {
  const { search_term, include_archived } = props.filters;
  const hasSearchFilter = search_term && search_term.trim();
  const hasFilters = hasSearchFilter || include_archived;

  return hasFilters ? (
    <div className="translations-table-filters">
      Filtered by:&nbsp;
      {hasSearchFilter && <span className="ui label"><span className="filter-label">Search Term: </span>{search_term}</span>}
      {include_archived && <span className="ui label"><span className="filter-label">Showing archived controls</span></span>}
    </div>
  ) : null;
}



// WEBPACK FOOTER //
// ./src/views/control_library/table/tanslations_modal/translation_modal_content/tanslations_table_filters.js